import React from 'react';
import { FaUserCheck} from "react-icons/fa";
import { useNavigate } from 'react-router';
import { IoArrowUndo } from "react-icons/io5";
import { GoGraph } from "react-icons/go";
import '../../CSS/Herramientas.css'
import ResumenOfi from './ResumenOfi';

function AdmonAsisOfis() {

    const catalogos =[
        {id:1,nombre: "Asistencia oficina",enlace: "AsisOficina"},
        {id:2,nombre: "Pagos de oficina",enlace: "PagosOficina"},
        {id:3,nombre: "Gastos de oficina",enlace: "GastosOficina"}
    ]
    const icons =[FaUserCheck,FaUserCheck,FaUserCheck,FaUserCheck]
    const navigate = useNavigate()

    const select = (direccion) => {
        navigate(direccion)
    }
    const regresar = () => {
        navigate('/inicio')
    }

    return (
        <div className='herramientas' >
            <ResumenOfi/>
        <div>
            <IoArrowUndo title="REGRESAR" onClick={regresar} style={{position:'absolute', right:'40px', top:'60px', fontSize:'40px', cursor:'pointer', color:'#1A2E4F'}}/>
        </div>
            <div id="two-column">
                <div style={{padding:"10px"}}>
                    <h3 className='tituloGastos'>OFICINA</h3>
                    <div className='card btncolor btn' style={{textAlign: "center", fontSize:'20px',margin:"30px"}} data-bs-toggle="modal" data-bs-target="#modal-resumen-oficina" >
                                    <div style={{display:'flex', justifyContent:'space-between'}}>
                                        <div style={{justifyContent:'center'}}>Resumen</div>
                                        <div style={{fontSize:'20px',justifyContent:'center'}}><GoGraph /></div>
                                    </div>            
                    </div>
                    {catalogos.map((cat,idx) =>{
                        const Icon = icons[idx] 
                        return(                            
                            <div  key={cat.id}>
                                <div className='card h-100 btncolor btn' style={{ margin:"30px", textAlign: "center", fontSize:'20px'}} onClick={() => select(cat.enlace)}>
                                    <div style={{display:'flex', justifyContent:'space-between'}}>
                                        <div style={{justifyContent:'center'}}>{cat.nombre}</div>
                                        <div style={{fontSize:'20px',justifyContent:'center'}}><Icon /></div>
                                    </div>            
                                </div>
                            </div>
                        )           
                    })}
                </div>

                <div style={{padding:"10px"}}>
                    <h3 className='tituloGastos'>CAMPO</h3>
                    <div className='card btncolor btn' style={{textAlign: "center", fontSize:'20px',margin:"30px"}} onClick={() => select("PagosCampo")}>
                                    <div style={{display:'flex', justifyContent:'space-between'}}>
                                        <div style={{justifyContent:'center'}}>Pagos</div>
                                        <div style={{fontSize:'20px',justifyContent:'center'}}><GoGraph /></div>
                                    </div>            
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdmonAsisOfis;